// extracted by mini-css-extract-plugin
export default {"msgM":"_08553d9e96"};